<template>
  <div>
    <div v-if="sellers.length > 0">
      <Table :columns="columns" :data="sellers">
        <template #edit="{ row }">
          <PencilIcon class="h-5 cursor-pointer" @click="() => openUpdateModal(row.id)" />
        </template>
        <template #delete="{ row }">
          <TrashIcon class="h-5 cursor-pointer" @click="() => deleteSeller(row.id)" />
        </template>
      </Table>
    </div>
    <div v-else class="text-center text-sm text-gray-500">Aucun vendeur n'est associé à cette boutique.</div>
    <SellerUpdate
      :isOpen="isUpdateSellerModalOpen"
      :selectedSeller="selectedSeller"
      @closeSellerUpdate="isUpdateSellerModalOpen = false"
      @getSellers="getSellers"
    />
  </div>
</template>

<script>
import { PencilIcon, TrashIcon } from "@heroicons/vue/outline";
import { Table } from "@estaly/ui";
import SellerUpdate from "@/components/store/details/sellers/SellerUpdate.vue";

export default {
  components: {
    PencilIcon,
    TrashIcon,
    Table,
    SellerUpdate,
  },

  props: {
    sellers: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isUpdateSellerModalOpen: false,
      selectedSeller: {},
    };
  },

  computed: {
    columns() {
      return [
        { label: this.$t("Id"), field: "id", widthClass: "w-16" },
        { label: this.$t("Name"), field: "name" },
        { label: this.$t("Email"), field: "email" },
        { label: this.$t("Phone"), field: "phone" },
        { label: "", field: "edit", slot: "edit" },
        { label: "", field: "delete", slot: "delete" },
      ];
    },
  },

  methods: {
    openUpdateModal(sellerId) {
      this.selectedSeller = this.sellers.find((seller) => seller.id === sellerId);
      this.isUpdateSellerModalOpen = true;
    },

    getSellers() {
      this.$emit("getSellers");
    },

    deleteSeller(sellerId) {
      if (confirm("Êtes-vous sûr de vouloir supprimer ce vendeur ? Cette action est irréversible.")) {
        this.$emit("deleteSeller", sellerId);
      }
    },
  },
};
</script>
